import GeoContext from 'contexts/geoContext'
import { useContext } from 'react'

const ultraluxContact: App.GeoContact = {
  humanReadable: '1300 860 454',
  number: '1300860454',
}

function useUltraLuxContact(): App.GeoContact {
  const { currentRegionCode, currentContact } = useContext(GeoContext)

  if (currentRegionCode === 'AU') {
    return ultraluxContact
  }
  return currentContact[currentContact.default]
}

export default useUltraLuxContact
